export default "__VITE_ASSET__534203cf__"